'use client';

import React from 'react';
import { OrderAddresses } from '@/ui/components/shared/order-details/order-addresses/order-addresses';
import { useOrderReceivedData } from '@/ui/providers/order-received-data-provider';

/**
 * The delivery-info tile renders the shipping and billing addresses set at checkout via the shared
 * OrderAddresses card, which supplies its own default titles.
 */
export function DeliveryInfo() {
  const data = useOrderReceivedData();

  if (!data) {
    return null;
  }

  return <OrderAddresses shipping={data.shippingAddress} billing={data.billingAddress} />;
}
